import { render, staticRenderFns } from "./UserPropertySettings.vue?vue&type=template&id=25487f59"
import script from "./UserPropertySettings.vue?vue&type=script&lang=ts"
export * from "./UserPropertySettings.vue?vue&type=script&lang=ts"
import style0 from "./UserPropertySettings.vue?vue&type=style&index=0&id=25487f59&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.4.23_cache-loader@4.1.0_webpack@4.47.0_webpack-cli@3.3_rzr6sqiw3iaxcjpfollk37er5e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports